import { DefaultService } from '@/services/DefaultService';

export default class ConfigurarRecibosService extends DefaultService {

  constructor(http, router, env) {
      super(http, router, env)
  }

  save(form) {
    return this._http.post(`${this._env}/despesa/configrecibo`, form, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  find(id) {
    return this._http.get(`${this._env}/despesa/configrecibo/${id}.json`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  findAll(column, order, page, limit, situacao, ...params) {
    return this._http.get(encodeURI(`${this._env}/despesa/configrecibo.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
    });
  }

  findAllNoPagination(identificador) {
    return this._http.get(`${this._env}/despesa/configrecibo/${identificador}/listallwithoutlimit.json?`, this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
    });
  }
  
  findEnums() {
    return this._http.get(`${this._env}/despesa/configrecibo/enums`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }
  
  updateSituacao(recibo) {
    return this._http.post(`${this._env}/despesa/configrecibo/updatesituacao`, recibo, this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw err;
    });
}

  downloadJasper(id) {
    let headCopy = { ...this._headers};
    headCopy.responseType = 'arraybuffer';
    return this._http.get(`${this._env}/despesa/configrecibo/${id}/download`, headCopy).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw err;
    });
  }

}